<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    import MixinWx from '@/mixin/user'
    export default{
        name: 'APP',
        mixins: [ MixinWx ],
    }
</script>

<style lang="scss">
    @import './styles/index.scss'; // 全局自定义的css样式
    
    .area-select.medium {
        width: 142px;
        margin-left: 0px !important;
        line-height: 32px;
    }
    .area-select .area-selected-trigger{
        padding-top: 0px !important;
    }
</style>



// WEBPACK FOOTER //
// App.vue?3e6a1d3a